import { addSetPrefix } from '@/services/utils.js';
import mdi from '@/icons/mdi/mdi.json';

export default Object.fromEntries(
    Object.entries(mdi).map(([key, value]) => [key, addSetPrefix(value)])
);
